/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export class ActionHandlerEvents {
}
ActionHandlerEvents.ACTION_PERFORMED_EVENT_KEY_PREFIX = 'sirius.action-handler.action-performed.';
ActionHandlerEvents.ACTION_UNAUTHORIZED_EVENT_KEY_PREFIX = 'sirius.action-handler.action-unauthorized.';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWN0aW9uLWhhbmRsZXIuZXZlbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3NoYXJlZC9hY3Rpb25zL2V2ZW50cy9hY3Rpb24taGFuZGxlci5ldmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7QUFDSCxNQUFNLE9BQU8sbUJBQW1COztBQUNMLHFEQUFpQyxHQUFHLHlDQUF5QyxDQUFDO0FBQzlFLHdEQUFvQyxHQUFHLDRDQUE0QyxDQUFDIn0=